import { OnboardingStageOne } from '../../pages';
import { useFileUpload } from 'use-file-upload';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { useStores } from '../../stores';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import React from 'react';

const OnboardingContainer = () => {
	const {
		appStore: { loading },
		businessStore,
	} = useStores();
	const navigate = useNavigate();
	const [file, selectFile] = useFileUpload();

	const selectClick = () => {
		selectFile({ accept: 'image/*' });
	};

	const validationSchema = () =>
		yup.object({
			address: yup.string().required('Please enter your address'),
			bizIndustry: yup.string().required('Please select a category'),
		});

	const switchToAlmostThere2 = () => {
		navigate(constant.Routes.OnboardingStageTwo);
	};

	const switchToAlmostThere3 = () => {
		navigate(constant.Routes.AlmostThereThree);
	};

	const onSubmit = async values => {
		let fileToSend;
		if (file && typeof file.source === 'string') {
			fileToSend = await fetch(file.source)
				.then(response => response.blob())
				.then(
					blob =>
						new File([blob], 'name', {
							type: blob.type,
							lastModified: new Date(),
						})
				);
			values.logo = fileToSend;
		}

		businessStore.setBusinessOnboardingStageOne(values);
		return navigate(constant.Routes.OnboardingStageTwo, values);
	};

	return (
		<div>
			<OnboardingStageOne
				validationSchema={validationSchema}
				onSubmit={onSubmit}
				loading={loading}
				switchToAlmostThere2={switchToAlmostThere2}
				switchToAlmostThere3={switchToAlmostThere3}
				file={file}
				selectClick={selectClick}
			/>
		</div>
	);
};

export default observer(OnboardingContainer);
